import { Prescription } from "./prescription";


export class Referral {
  constructor() {
    this.prescription=new Prescription();
  }

  public doctorName?: string;
  public doctorId?: string;
  public clinicDoc?: string;
  public doctorSpecialty?: string;
  public prescriptionDate?: string;
  public patientName?: string;
  public patientFirstName?: string;
  public patientLastName?: string;
  public patientBirthDate?: string;
  public patientGender?: string;
  public patientInsuranceType?: string;
  public samadCode: string | undefined;
  
  public prescription: Prescription;

  public token?: string;
  public citizenToken?: string;
  public saleFactorType?: number;
}
